import fetchServer from "../fetchServer";

export default async function cancelPriceFreeze(priceFreezeId) {
  let result = {
    return: 0,
    msg: "Failed to cancel price freeze",
  };

  if (!priceFreezeId) {
    result.msg = "Price freeze ID is missing";
    return result;
  }

  await fetchServer({
    method: "POST",
    url: `/payment/v1/payment/cancel-price-freeze/${priceFreezeId}`,
  })
    .then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        result = {
          return: 1,
          msg: res?.data?.message || "Price freeze cancelled successfully",
          data: res?.data?.data,
        };
        return;
      }

      result.msg =
        res?.data?.error ||
        res?.error ||
        res?.data?.message ||
        res?.message ||
        result.msg;

      if (typeof result.msg !== "string") {
        result.msg =
          result.msg?.message ||
          result.msg?.error ||
          "Failed to cancel price freeze";
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result.msg = "Network Error!";
      } else if (err?.message) {
        result.msg = err.message;
      }
    });

  return result;
}
